import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { addDays, endOfDay, isAfter, startOfDay } from 'date-fns';

export function minDateValidator(min: Date): ValidatorFn {
    return (control: AbstractControl<Date>): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }

        const valid = isAfter(endOfDay(value), startOfDay(min));
        return valid
            ? null
            : { minDate: { value: addDays(min, -1).toLocaleDateString() } };
    };
}
